<template>
  <Dialog
    v-loading="loading.user"
    title="Edit Dashboard"
    :show="isOpen"
    :onClose="onClose"
  >
    <el-form
      :model="item"
      label-width="120px"
      label-position="left"
      size="small"
    >
      <el-form-item label="Owner">
        <el-input v-model="item.email" disabled />
      </el-form-item>

      <el-form-item label="Notes">
        <el-input
          type="textarea"
          autosize
          placeholder="Please input"
          v-model="payload.notes"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">Save</el-button>
        <el-button @click="onClose()">Cancel</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</template>

<script>
import { pick } from "lodash";
import { mapGetters, mapActions } from "vuex";
import Dialog from "@/components/Dialog";

export default {
  data() {
    return {
      payload: {},
    };
  },
  props: {
    item: Object,
    isOpen: Boolean,
    onClose: Function,
  },
  emits: ["saved"],
  components: {
    Dialog,
  },
  computed: {
    ...mapGetters(["user", "loading"]),
  },
  methods: {
    ...mapActions(["getUser", "updateUser"]),
    async fetchData() {
      try {
        if (this.item?.owner_id) {
          await this.getUser(this.item.owner_id);
          this.payload = { ...this.user };
        }
      } catch (e) {
        this.$notify.error({
          title: "Couldn't fetch all user info :(",
        });
      }
    },
    async save() {
      try {
        const { id } = this.payload;
        const payload = pick(this.payload, ["notes"]);
        await this.updateUser({ id, payload });

        this.$message.success("Saved successfully");
        this.$emit("saved");
        this.onClose();
      } catch (error) {
        this.$notify.error({
          title: "Save failed. :(",
          message: error.message,
        });
      }
    },
  },
  watch: {
    item: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
};
</script>
